/**
 * `SoftDeletedBanner` - warning banner shown when an account is closed or
 * soft-deleted. Per the MUR "Mockups" page detail-page wireframe: appears at the
 * top of the page so the CSA reading the screen is unambiguously told
 * "this account is not live - the values below are shown for reference".
 *
 * Renders only when `status` is `closed` or `deleted`.
 */
import type { Account } from '../../../lib/bff-client'
import { Timestamp } from './section'

export interface SoftDeletedBannerProps {
  readonly account: Account
}

export function SoftDeletedBanner({ account }: SoftDeletedBannerProps): JSX.Element | null {
  if (account.status !== 'closed' && account.status !== 'deleted') {
    return null
  }
  return (
    <div
      role="status"
      className="flex flex-col gap-murmuration-1 rounded-md border border-status-warning bg-status-warning-bg px-murmuration-4 py-murmuration-3"
    >
      <p className="text-murmuration-body-strong text-status-warning">
        This account is {account.status} - shown for reference only.
      </p>
      {account.deleted_at !== null && (
        <p className="text-murmuration-body text-text-secondary">
          deleted_at: <Timestamp value={account.deleted_at} />
        </p>
      )}
    </div>
  )
}
